import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";


export const legalApi = createApi({
  reducerPath: 'legal',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['legal'],
  endpoints: (builder) => ({
    getLegals: builder.query({
      query: (type) => ({
        url: `/admin/legal?type=${type}`,
        method: 'GET',
      }),
      transformResponse: (res) => res,
      invalidatesTags: ['legal'],
    }),

    updateLegals: builder.mutation({
      query: (data) => ({
        url: `/admin/legal`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['legal'],
    }),

    getPrivacyPolicy: builder.query({
      query: () => ({
        url: `/privacy-policy`,
        method: 'GET',
      }),
      transformResponse: (res) => res,
    }),

  }),
});

export const { useGetLegalsQuery, useUpdateLegalsMutation, useGetPrivacyPolicyQuery } = legalApi;